<template>
  <div id="app">
    <router-view></router-view>
    <tips-wrap />
  </div>
</template>

<script>
import TipsWrap from "@/components/tips";
import $wx from "@/assets/js/wxshare.js";
export default {
  name: "App",
  components: {
    TipsWrap,
  },
  created() {
    var tokenStr = localStorage.getItem("user_token");
    if (!tokenStr) {
      console.log("token不存在 获取新的token");
      this.updataToken();
    } else {
      // console.log("token存在");
      this.$store.commit("setUserToken", tokenStr);
    }
    if (this.isWeiXin()) {
      this.getShareData()
    }
  },
  methods: {
    getShareData() {
      this.$axiosApi.getShareData().then((res) => {
        if (res.data.code == 9) {
          this.$store.commit("setShareData", res.data.data);
          var data = {
            thumb: res.data.data.thumb,
            title: res.data.data.title,
            description: res.data.data.description,
            url: location.href,
          };
          $wx.getWxShare(data);
        }else{
          getShareData();
        }
      });
    },
    updataToken() {
      this.$axiosApi.getToken().then((res) => {
        console.log('updataToken',res.data.data);
        localStorage.setItem("user_token", res.data.data);
        this.$store.commit("setUserToken", res.data.data);
      });
    },
    isWeiXin() {
      return (
        window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) ==
        "micromessenger"
      );
    },
  },
  mounted() {},
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
html,
body {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}
ul,
li {
  list-style: none;
}
a {
  text-decoration: none;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  width: 100%;
  height: 100%;
  font-size: 0.24rem;
}
html {
  font-size: 13.333333333333334vw;
}
@font-face {
  font-family: "iconfont"; /* project id 2126703 */
  src: url("//at.alicdn.com/t/font_2126703_atf4gy892nl.eot");
  src: url("//at.alicdn.com/t/font_2126703_atf4gy892nl.eot?#iefix")
      format("embedded-opentype"),
    url("//at.alicdn.com/t/font_2126703_atf4gy892nl.woff2") format("woff2"),
    url("//at.alicdn.com/t/font_2126703_atf4gy892nl.woff") format("woff"),
    url("//at.alicdn.com/t/font_2126703_atf4gy892nl.ttf") format("truetype"),
    url("//at.alicdn.com/t/font_2126703_atf4gy892nl.svg#iconfont") format("svg");
}
.iconfont {
  font-family: "iconfont" !important;
  font-size: 0.32rem;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}
#app {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue